import Styles from './XLoadingPreview.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const XLoadingPreview = () => {
  return (
    <div className={Styles.xLoadingPreview}>
      <div className={Styles.header}>
        <Skeleton avatar={{ size: 40 }} active paragraph={{ rows: 3, width: 69 }} title={false} />
      </div>
      <div className={Styles.body}></div>
      <div className={Styles.footer}>
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: 32 }} title={false} />
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: 32 }} title={false} />
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: 32 }} title={false} />
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: 32 }} title={false} />
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: 32 }} title={false} />
      </div>
    </div>
  )
}
